<template>
  <div class="zyc-page-table-content mt20" ref="fullScreen">
    <el-dialog :title="title"
               :modal-append-to-body="false"
               :visible.sync="isDialog"
               width="1400px">
      <div style="width: 1360px; overflow-x: auto;" class="zyc-nav-class-content">
        <table class="zyc-table" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <template v-for="(v,k) in data[0]">
                <th>{{ k }}</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <div v-if="isLoading" class="el-loading-mask" style=""><div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div></div>
            <template v-if="!isLoading">
              <div v-if="data.length < 1" class="zyc-page-table-empty">
                <h1>没有找到和查询条件相符的数据，原因可能是:<span>搜索的数据超出数据库查询范围</span></h1>
              </div>
            </template>
            <tr v-for="(i,index) in data" @click="onRowClick(i)">
              <template v-for="c in i">
                <td :style="{ width: '120px', 'text-align': 'center' }">
                  <div :style="{ width: '120px','text-align': 'center' }"><zyc-tooltipText :title="c"></zyc-tooltipText></div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      
      <el-pagination v-if="total" @size-change="pageSizeChange"
                   @current-change="pageIndexChange"
                   :current-page="pageIndex"
                   :page-sizes="[10, 30, 50]"
                   :page-size="pageSize"
                   layout="total, sizes,slot, prev, pager, next, jumper"
                   class="mt20"
                   :pager-count="5"
                   :total="total"></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="isDownload" :disabled="isDownload" @click="onDownload">
          {{ isDownload ? '下载中' : '下载' }}
        </el-button>
        <el-button @click="isDialog = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import { getMap, getMapDownload } from '@/plugins/api/public';

  /**
  * 排行Table
  */
  export default {
    name: 'zycPageListTable',
    props: {
      type: {
        type: String,
      },
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
        isDialog: false,
        isLoading: false,
        title: '',
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        isDownload: false,
        data: [],
        columns: [],
        options: [{
          value: 10,
          label: '10条/页'
        }, {
          value: 30,
          label: '30条/页'
        }, {
          value: 50,
          label: '50条/页'
        }],
        item: null,
        searchData: {}
      }
    },
    mounted() {
      console.log('11111111')
    },
    created() {
      this.$nextTick(() => {
      })
    },
    methods: {
      show(o,searchData) {
        this.isDialog = true;
        this.title = o.title;
        this.item = o
        this.searchData = searchData
        this.init()
      },
      onDownload(){
        console.log('onDownload')
        this.isDownload = true
        const params = {
          ...this.searchData,
          current: 1,
          size: 50000
        }
        getMapDownload('clickhouse-typeAnalysis-titleYear-'+ this.item.type, params).then(res => {
          this.isDownload = false
          const blob = res;
          if (!blob || blob.size === 0) {
            this.$message.warning('下载内容为空')
            return
          }
          // 创建下载链接
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.item.title + '.xlsx';
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }).catch(() => {
          this.isDownload = false
          this.$message.error('下载失败，请稍后重试')
        })
      },
      init(){
         this.isLoading = true
          this.searchData.current = this.pageIndex
          this.searchData.size = this.pageSize
          getMap('clickhouse-typeAnalysis-titleYear-'+ this.item.type,this.searchData).then(res=>{
            this.isLoading = false
            this.data = res.data.list.records
            this.columns = res.data.columns
            this.total = res.data.list.total
            console.log(res)
          })
      },
      pageSizeChange(val) {
        this.pageIndex = 1
        this.pageSize = val
        this.init()
      },
      pageIndexChange(val) {
        this.pageIndex = val
        this.init()
      },
      onRowClick(row){
        console.log(row)
        const page = this.$router.resolve({
        path: "/enterprise/PatentValueAnalysis/PatentListOnly",
        query: {
          ano: row.申请号,
          publicationNumber: row['公开（公告）号']
        }
      })
      window.open(page.href, "_blank")
      },
    }
  }
</script>
<style scoped lang="scss">
  /deep/ .el-pagination {
    .more + .number {
      display: none;
    }
  }
  /deep/ .baogao .el-dialog .el-dialog__body{
    max-height: 800px!important;
    padding-bottom: 20px;
  }

  /deep/ .el-dialog .el-transfer__buttons{
    padding: 0 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/zyc/table/pageListTable.vue